import { render, staticRenderFns } from "./CbrAvaliabilityPage.vue?vue&type=template&id=66a71117&lang=pug"
import script from "./CbrAvaliabilityPage.vue?vue&type=script&lang=js"
export * from "./CbrAvaliabilityPage.vue?vue&type=script&lang=js"
import style0 from "./CbrAvaliabilityPage.vue?vue&type=style&index=0&id=66a71117&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports